import { ApiHatasi } from "./api";

/**
 * ================================================================
 * ARIZAYI TEŞHİS EDİLEBİLİR KILAN KİMLİK — ARIZA ANINDA DÜŞÜYORDU
 * ================================================================
 * Öğrenci PWA oturumu ölçtü (05.09.2026) ve panelde de aynısını buldu:
 * sunucu `X-Istek-Id` başlığını **her** yanıta koyuyor
 * (`context.middleware.ts:35`), `request-context.ts` kendi amacını
 * *"bir tıklamanın doğurduğu bütün olayları"* bağlamak diye yazıyor,
 * `Hata500` çizimi ekranda göstermeyi **açıkça istiyor** — ve
 * **hiçbir istemci okumuyordu.**
 *
 * Sonucu: bir şey bozulduğunda kullanıcının söyleyebileceği tek şey
 * *"bir hata aldım"*. Desteğin o isteği kayıtlarda bulmasının yolu yok.
 *
 * Yani teşhis için üretilmiş bilgi, **tam da teşhis gereken anda**
 * kayboluyordu — bu depoda tekrar eden sınıfın en pahalı biçimi:
 * *bilgi vardı, onu götürecek yol yoktu.*
 *
 * ================================================================
 * YALNIZCA 5xx'TE — VE SEBEBİ
 * ================================================================
 * 4xx'te mesaj zaten kullanıcının **yapabileceği** bir şeyi anlatıyor
 * ("bu alan zorunlu", "yetkiniz yok"). Oraya teknik bir kimlik
 * eklemek gürültü olurdu — ve gürültü, kimliğin **gerçekten gerektiği**
 * yerde okunmamasına yol açar.
 *
 * 5xx'te kullanıcının yapabileceği bir şey yok; tek işe yarar bilgi
 * o kimlik.
 *
 * ================================================================
 * NEDEN ÖĞRENCİ SÜRÜMÜNDEN AYRI BİR DOSYA
 * ================================================================
 * İki uygulamanın `ApiHatasi` sınıfları **ayrı** (`apps/panel/src/api.ts`
 * ve `apps/ogrenci/src/api.ts`) ve alan adları bile aynı değil —
 * öğrencide `sunucuArizasiMi`, panelde `sunucuHatasiMi`. Ortak bir
 * modüle çıkarmak, önce o iki sınıfı birleştirmeyi gerektirir; bu
 * dosya o işi yapmadan **kuralı** taşıyor.
 *
 * ⚠️ Kural iki evde ve bunu biliyoruz. Kabul edilebilir olmasının tek
 * sebebi, ikisinin de aynı gün ve aynı gerekçeyle yazılmış olması.
 * `ApiHatasi` birleştirildiği gün bu dosya da birleşmeli.
 *
 * Dil farkı da bilinçli: öğrenciye **"ilet"**, panel kullanıcısına
 * **"iletin"**. Panel personelin, öğrenci uygulaması öğrencinin.
 */
export function hataMetni(err: unknown, varsayilan: string): string {
  if (err instanceof ApiHatasi) {
    if (err.sunucuHatasiMi && err.istekId) {
      /*
        Kimlik CÜMLENİN SONUNDA ve ne işe yaradığı yazılı. Yalnızca
        kodu basmak, kullanıcıya anlamını bilmediği bir dizi vermek
        olurdu — kimse onu kimseye iletmezdi.
      */
      return `${err.message} Sorun sürerse bu kimliği iletin: ${err.istekId}`;
    }
    return err.message;
  }
  return err instanceof Error ? err.message : varsayilan;
}
